import xpHigh from 'assets/wheel/xp-high.png';
import xpLow from 'assets/wheel/xp-low.png';
import xpMedium from 'assets/wheel/xp-medium.png';

const rewardThresholds: [number, string][] = [
  [0.01, 'var(--c-yellow-700)'],
  [0.02, '#FF00C0'],
  [0.1, 'var(--c-green-400)'],
  [1, 'var(--c-nd-500)'],
] as const;

export const findRewardThresholdColor = (score: number) => {
  const threshold = rewardThresholds.find(([t]) => score < t);
  return threshold?.[1] ?? 'var(--c-nd-500)';
};

export const getXpIllustration = (xp: number) => {
  if (xp < 1000) {
    return xpLow;
  }
  if (xp < 2000) {
    return xpMedium;
  }
  return xpHigh;
};
